function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from "axios";
//@ts-ignore
import { MAP_TILER_STYLE } from "@wkWebSrc/js/components/variables";
var SVG = "<svg viewBox=\"0 0 128 128\" class=\"icon-spin\"><circle class=\"path\" cx=\"64\" cy=\"64\" r=\"42\" fill=\"none\" stroke-width=\"9\"></circle></svg>";
import "core-js/modules/es.array.iterator";
//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
var FreeDraw;
var L;
export var MAX_ZOOM = 18;
var token = "pk.eyJ1Ijoid2lraWNhc2EiLCJhIjoiY2pqZnVlNXFrMHRzMTNwcGF4aXd2a3N5ZiJ9.BctgdXWxGJ9JRMp2U-SyRw";
var defaultDrawingOptions = function defaultDrawingOptions(COLORS) {
  return {
    guidelineDistance: 15,
    showArea: true,
    fillColor: COLORS.lightPrimary,
    fillOpacity: 0.75,
    color: COLORS.primary,
    opacity: 1,
    weight: 3,
    zIndex: 1,
    stroke: true,
    fill: true,
    clickable: true
  };
};
var drawingOptions;
/**
 * @author Andrea Moraglia
 */
var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
    this.touch = true;
    this.callbacks = [];
    this.markers = new Map();
    this.initialized = false;
    this.drawing = false;
  }
  return _createClass(_default, [{
    key: "findMarker",
    value: function findMarker(id) {
      return this.markers.get(id);
    }
  }, {
    key: "highlightCluster",
    value: function highlightCluster(cluster) {
      if (!cluster) return;
      if (this.clusterHightlight) this.clearHighlight();
      this.clusterHightlight = cluster;
      this.clusterHightlight._icon.classList.add("marker-cluster-selected");
    }
  }, {
    key: "clearHighlight",
    value: function clearHighlight() {
      if (this.clusterHightlight && this.clusterHightlight._icon) this.clusterHightlight._icon.classList.remove("marker-cluster-selected");
    }
  }, {
    key: "addMarkerBulk",
    value: function addMarkerBulk(data, center, limit) {
      var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "".concat(window["_cdn"], "/_ui/img/Ico/pin-blue.svg");
      var bulk = [];
      if (center && !this.validateCoordinate(center.lat, center.lng)) center = null;
      //@ts-ignore
      var mapRange = limit ? limit : window["_mapRange"] || 10000;
      for (var i = 0; i < data.length; i++) {
        var position = {
          lat: data[i].latitude,
          lng: data[i].longitude
        };
        if (!center || this.getDistance(center, position) < mapRange) {
          var markerIconUrl = icon; // Imposta l'URL dell'icona per il marker corrente
          var markerIcon = void 0;
          if (data[i].auction) {
            markerIconUrl = "".concat(window["_cdn"], "/_ui/img/map/marker-auction.svg");
            markerIcon = L.icon({
              iconUrl: markerIconUrl,
              iconSize: [40, 40]
            });
          } else {
            markerIcon = L.icon({
              iconUrl: markerIconUrl,
              iconSize: [40, 40],
              iconAnchor: [20, 40]
            });
          }
          var marker = L.marker(position, {
            icon: markerIcon
          });
          marker.id = data[i].id;
          this.markers.set(data[i].id, marker);
          if (this.markerClusterer) {
            bulk.push(marker);
          } else marker.addTo(this.map);
        }
      }
      if (bulk.length > 0) this.markerClusterer.addLayers(bulk);
    }
  }, {
    key: "addMarker",
    value: function addMarker(key, position, icon, cluster) {
      var defOpts = {
        //@ts-ignore
        iconUrl: icon ? icon : "".concat(window["_cdn"], "/_ui/img/Ico/pin-blue.svg"),
        iconSize: [48, 48],
        iconAnchor: [24, 48]
      };
      var iconOpts = Object.assign({}, defOpts);
      shallowCopyObjectTo(icon, defOpts);
      var myIcon = L.icon(iconOpts);
      var marker = L.marker(position, {
        icon: myIcon
      });
      if (key != null) {
        marker.id = key;
        this.markers.set(key, marker);
      }
      if (this.markerClusterer) {
        this.markerClusterer.addLayer(marker);
      } else {
        marker.addTo(this.map);
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(id) {
      var marker = this.findMarker(id);
      if (marker) this.map.removeLayer(marker);
    }
  }, {
    key: "initMarkerClusterer",
    value: function initMarkerClusterer() {
      var options = {
        showCoverageOnHover: true,
        spiderfyOnMaxZoom: false,
        spiderLegPolylineOptions: {
          color: drawingOptions.color
        },
        singleMarkerMode: false
      };
      var self = this;
      return new Promise(function (resolve, reject) {
        Promise.all([require( /* webpackChunkName: "chunks/leaflet.markercluster" */"leaflet.markercluster/dist/MarkerCluster.css"), import( /* webpackChunkName: "chunks/leaflet.markercluster" */"leaflet.markercluster")]).then(function () {
          self.markerClusterer = L.markerClusterGroup(options);
          self.map.addLayer(self.markerClusterer);
          resolve();
        })["catch"](function (error) {
          console.error(error);
          reject();
        });
      });
    }
  }, {
    key: "disableControls",
    value: function disableControls() {
      this.map.boxZoom.disable();
      this.map.doubleClickZoom.disable();
      this.map.dragging.disable();
      this.map.keyboard.disable();
      this.map.scrollWheelZoom.disable();
      this.map.touchZoom.disable();
    }
  }, {
    key: "enableControls",
    value: function enableControls() {
      this.map.boxZoom.enable();
      this.map.doubleClickZoom.enable();
      this.map.dragging.enable();
      this.map.keyboard.enable();
      this.map.scrollWheelZoom.enable();
      this.map.touchZoom.enable();
    }
  }, {
    key: "setDrawing",
    value: function setDrawing() {
      this.stopDrawing();
      this.disableControls();
      if (this.freeDraw) {
        this.freeDraw.mode(FreeDraw.CREATE);
        this.map["touchExtend"].enable();
      }
      if (this.shapeLayer) {
        this.drawHandler = new L.Draw.Polygon(this.map, drawingOptions);
        this.drawHandler.enable();
      }
      this.drawing = true;
    }
  }, {
    key: "stopDrawing",
    value: function stopDrawing() {
      this.enableControls();
      if (this.freeDraw) {
        this.map["touchExtend"].disable();
        this.freeDraw.cancel();
        this.freeDraw.mode(FreeDraw.EDIT);
      }
      if (this.drawHandler) this.drawHandler.disable();
      this.drawing = false;
    }
  }, {
    key: "initDrawingManager",
    value: function initDrawingManager() {
      var _this = this;
      if (!this.touch) {
        return new Promise(function (resolve, reject) {
          Promise.all([import( /* webpackChunkName: "chunks/leaflet.draw" */"leaflet-draw"), require( /* webpackChunkName: "chunks/leaflet.draw" */"leaflet-draw/dist/leaflet.draw.css")]).then(function () {
            _this.shapeLayer = new L.FeatureGroup();
            _this.map.addLayer(_this.shapeLayer);
            _this.map.on("draw:created", function (e) {
              var polygon = e.layer;
              _this.shapeLayer.clearLayers();
              _this.shapeLayer.addLayer(polygon);
              polygon.options.editing || (polygon.options.editing = {});
              polygon.editing.enable();
              _this.fitBounds(polygon.getBounds());
            });
            L.drawLocal.draw.handlers.polygon.tooltip = {
              start: "Clicca per iniziare a disegnare il poligono",
              cont: "Clicca per continuare a disegnare il poligono",
              end: "Clicca sul primo punto per chiudere il poligono"
            };
            resolve();
          })["catch"](function (error) {
            console.error(error);
            reject();
          });
        });
      } else {
        return new Promise(function (resolve, reject) {
          import( /* webpackChunkName: "chunks/leaflet.freedraw" */"leaflet-freedraw").then(function (module) {
            FreeDraw = module["default"];
            _this.freeDraw = new FreeDraw();
            _this.freeDraw.on("markers", function (e) {
              if (e.eventType === "create" && e.latLngs.length && e.latLngs[0].length > 2) {
                var polygon = L.polygon(e.latLngs, drawingOptions);
                _this.fitBounds(polygon.getBounds());
                _this.map.fire("draw:created", {
                  originalEvent: e,
                  layer: polygon
                });
                _this.stopDrawing();
              }
            });
            _this.map.addLayer(_this.freeDraw);
            _this.freeDraw.mode(FreeDraw.NONE);
            resolve();
          })["catch"](function (error) {
            console.error(error);
            reject();
          });
        });
      }
    }
  }, {
    key: "drawPolygonFromPoints",
    value: function drawPolygonFromPoints(latLngs) {
      if (!latLngs) return;
      var polygon = L.polygon(latLngs, drawingOptions);
      if (this.freeDraw) this.freeDraw.create(polygon.getLatLngs()[0]);else if (this.shapeLayer) this.shapeLayer.addLayer(polygon);else {
        this.shapeLayer = new L.FeatureGroup();
        this.map.addLayer(this.shapeLayer);
        this.shapeLayer.addLayer(polygon);
      }
      this.map.fire("draw:created", {
        layer: polygon
      });
    }
  }, {
    key: "deleteMarkers",
    value: function deleteMarkers() {
      var keys = Object.keys(this.markers);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var marker = this.findMarker(Number(key));
        if (marker) this.map.removeLayer(marker);
      }
      this.markers.clear();
      if (this.markerClusterer) this.markerClusterer.clearLayers();
    }
  }, {
    key: "deleteShape",
    value: function deleteShape() {
      if (this.freeDraw) this.freeDraw.clear();
      if (this.shapeLayer) this.shapeLayer.clearLayers();
      this.map.fire("draw:deleted");
    }
  }, {
    key: "hasShape",
    value: function hasShape() {
      return this.freeDraw && this.freeDraw.size() > 0 || this.shapeLayer && this.shapeLayer.getLayers().length > 0;
    }
  }, {
    key: "getShape",
    value: function getShape() {
      return this.freeDraw ? this.freeDraw.all()[0] : this.shapeLayer ? this.shapeLayer.getLayers()[0] : null;
    }
  }, {
    key: "getShapePoints",
    value: function getShapePoints() {
      var _a, _b;
      return (_b = (_a = this.getShape()) === null || _a === void 0 ? void 0 : _a.getLatLngs()[0]) !== null && _b !== void 0 ? _b : [];
    }
  }, {
    key: "initSearch",
    value: function initSearch() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        Promise.all([require( /* webpackChunkName: "chunks/leaflet.geocoder" */"leaflet-control-geocoder/dist/Control.Geocoder.css"),
        //@ts-ignore
        import( /* webpackChunkName: "chunks/leaflet.geocoder" */"leaflet-control-geocoder")]).then(function () {
          _this2.search = new L.Control.Geocoder({
            defaultMarkGeocode: false,
            collapsed: false,
            placeholder: "Inserisci un indirizzo",
            errorMessage: "Nessun luogo trovato",
            geocoder: new L.Control.Geocoder.Mapbox(token, {
              serviceUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places/",
              geocodingQueryParams: {
                "language": "it"
              },
              reverseQueryParams: {}
            })
          }).on("markgeocode", function (e) {
            _this2.stopDrawing();
            _this2.deleteShape();
            _this2.fitBounds(e.geocode.bbox);
            _this2.setDrawing();
          }).addTo(_this2.map);
          resolve();
        })["catch"](function (error) {
          console.error(error);
          reject();
        });
      });
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return this.initialized;
    }
  }, {
    key: "getInfowindow",
    value: function getInfowindow() {
      return this.infowindow;
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return this.map;
    }
  }, {
    key: "getMapContainer",
    value: function getMapContainer() {
      return this.mapContainer;
    }
  }, {
    key: "getMarkersCount",
    value: function getMarkersCount() {
      return this.markers.size;
    }
  }, {
    key: "getMarkerClusterer",
    value: function getMarkerClusterer() {
      return this.markerClusterer;
    }
  }, {
    key: "addListener",
    value: function addListener(obj, event, fn) {
      obj.on(event, fn);
    }
  }, {
    key: "init",
    value: function init(selector, apiKey, COLORS, opts) {
      var longLat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var zoom = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 12;
      this.mapContainer = selector;
      if (!this.mapContainer || this.map) return;
      /* setting a default behaviour */
      this.touch = (opts === null || opts === void 0 ? void 0 : opts.touch) !== false;
      drawingOptions = defaultDrawingOptions(COLORS);
      var dataZoom = this.mapContainer.getAttribute("data-zoom");
      if (dataZoom) zoom = parseInt(dataZoom);
      var lat, lng;
      if (longLat) {
        lat = longLat.latitude;
        lng = longLat.longitude;
      } else {
        lat = parseFloat(this.mapContainer.getAttribute("data-lat") || String(0));
        lng = parseFloat(this.mapContainer.getAttribute("data-lng") || String(0));
      }
      var drawing = this.mapContainer.hasAttribute("data-drawing-manager");
      var search = this.mapContainer.hasAttribute("data-search");
      var cluster = this.mapContainer.hasAttribute("data-cluster");
      var center = [lat, lng];
      if (!this.validateCoordinate(center[0], center[1])) {
        center = [45.464161, 9.190336];
      }
      this.config = {
        zoom: zoom,
        center: center,
        cluster: cluster,
        search: search,
        drawing: drawing
      };
      this.load(this.config, apiKey, opts);
    }
  }, {
    key: "load",
    value: function load(config, apiKey, opts) {
      var _this3 = this;
      if (!this.spinner) {
        this.spinner = document.createElement("div");
        this.spinner.className = "spinner-wrapper";
        this.spinnerIcon = document.createElement("div");
        this.spinnerIcon.className = "spinner";
        this.spinnerIcon.innerHTML = SVG;
        this.spinner.appendChild(this.spinnerIcon);
        this.mapContainer.appendChild(this.spinner);
      }
      var defOpts = {
        maxZoom: MAX_ZOOM,
        zoomControl: false
      };
      var options = Object.assign({}, defOpts);
      shallowCopyObjectTo(opts, options);
      getL().then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          leaflet = _ref2[0];
        window["L"] = leaflet;
        L = leaflet;
        var self = _this3;
        if (_this3.touch) _this3.addTouchHandler();
        _this3.map = new L.Map(_this3.mapContainer, options);
        L.control.zoom({
          position: "bottomright"
        }).addTo(_this3.map);
        L.tileLayer("https://api.maptiler.com/maps/".concat(MAP_TILER_STYLE, "/{z}/{x}/{y}@2x.png?key=").concat(apiKey), {
          tileSize: 512,
          zoomOffset: -1,
          minZoom: 1,
          // eslint-disable-next-line max-len
          attribution: "<a href=\"https://www.maptiler.com/copyright/\" target=\"_blank\">© MapTiler</a> <a href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\">© OpenStreetMap contributors</a>",
          crossOrigin: true
        }).addTo(_this3.map);
        _this3.map.setView(config.center, config.zoom);
        // eslint-disable-next-line max-len
        _this3.infowindow = L.popup().setContent("<div id=\"infowindow\" class=\"infowindow \"><div id=\"wrapper-single\" class=\"wrapper-single\"></div><div id=\"wrapper-multiple\" class=\"wrapper-multiple tw-no-scrollbar tw-overflow-auto\"></div></div>");
        L.Control.infowindowCarousel = L.Control.extend({
          options: {
            position: "bottomleft"
          },
          onAdd: function onAdd(map) {
            this._div = L.DomUtil.create("div");
            this._div.id = "infowindow-carousel";
            this._div.className = "infowindow-carousel siema tw-bg-white tw-text-left tw-m-0 sm:tw-hidden";
            this._div.addEventListener("mouseover", function () {
              map.dragging.disable();
            });
            this._div.addEventListener("mouseout", function () {
              map.dragging.enable();
            });
            self.infowindowCarousel = this._div;
            return this._div;
          }
        });
        _this3.map.addControl(new L.Control.infowindowCarousel());
        Promise.all([config.search ? _this3.initSearch() : Promise.resolve(), config.cluster ? _this3.initMarkerClusterer() : Promise.resolve(), config.drawing ? _this3.initDrawingManager() : Promise.resolve(), new Promise(function (resolve) {
          return _this3.map.whenReady(function () {
            return resolve();
          });
        })]).then(function () {
          _this3.stopSpinner();
          _this3.mapContainer.dispatchEvent(new CustomEvent("ready", {
            detail: {
              description: "Map init is complete"
            },
            bubbles: true,
            cancelable: true
          }));
          _this3.initialized = true;
          for (var i = 0; i < _this3.callbacks.length; i++) {
            _this3.callbacks[i]();
          }
        });
      });
    }
  }, {
    key: "startSpinner",
    value: function startSpinner() {
      this.spinner.style.display = "block";
    }
  }, {
    key: "stopSpinner",
    value: function stopSpinner() {
      this.spinner.style.display = "none";
    }
  }, {
    key: "ready",
    value: function ready(fn) {
      if (this.isInitialized()) fn();else this.callbacks.push(fn);
    }
  }, {
    key: "on",
    value: function on(event, fn) {
      var _this4 = this;
      this.ready(function () {
        _this4.map.on(event, fn);
      });
    }
  }, {
    key: "setCenter",
    value: function setCenter(lat, lng) {
      var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 13;
      if (!this.map) return;
      if (!this.validateCoordinate(lat, lng)) return;
      this.map.setView([lat, lng], zoom);
    }
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {
      this.map.setView(this.map.getCenter(), zoom);
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return this.map.getZoom();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.stopDrawing();
      this.deleteShape();
      this.deleteMarkers();
    }
  }, {
    key: "fitBounds",
    value: function fitBounds(myBounds) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        padding: [0, 0]
      };
      // Andrea M: use LatLngBounds constructor to pass always real LatLngBounds class to fitBounds method
      this.map.fitBounds(L.latLngBounds(myBounds.getNorthEast(), myBounds.getSouthWest()), opts);
    }
  }, {
    key: "validateCoordinate",
    value: function validateCoordinate(lat, lng) {
      if (!lat || 0 === lat || 90 < Math.abs(lat)) {
        return false;
      }
      if (!lng || 0 === lng || 180 < Math.abs(lng)) {
        return false;
      }
      return true;
    }
  }, {
    key: "getDistance",
    value: function getDistance(latLng, otherLatLng) {
      return this.map.distance(latLng, otherLatLng);
    }
  }, {
    key: "geocode",
    value: function geocode(address) {
      return axios.get("https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(address, ".json?language=it&access_token=").concat(token));
    }
  }, {
    key: "addTouchHandler",
    value: function addTouchHandler() {
      L.Map.mergeOptions({
        touchExtend: true
      });
      L.Map.TouchExtend = L.Handler.extend({
        initialize: function initialize(map) {
          this._map = map;
          this._container = map.getContainer();
        },
        addHooks: function addHooks() {
          L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this);
          L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this);
          L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this);
        },
        removeHooks: function removeHooks() {
          L.DomEvent.off(this._container, "touchstart", this._onTouchStart, this);
          L.DomEvent.off(this._container, "touchend", this._onTouchEnd, this);
          L.DomEvent.off(this._container, "touchmove", this._onTouchMove, this);
        },
        _onTouchEvent: function _onTouchEvent(e, type) {
          if (!this._map._loaded) {
            return;
          }
          var touch = e.touches[0],
            rect = this._container.getBoundingClientRect(),
            lat = touch.clientX - rect.left - this._container.clientLeft,
            lng = touch.clientY - rect.top - this._container.clientTop,
            containerPoint = L.point(lat, lng),
            layerPoint = this._map.containerPointToLayerPoint(containerPoint),
            latlng = this._map.layerPointToLatLng(layerPoint);
          try {
            this._map.fire(type, {
              latlng: latlng,
              layerPoint: layerPoint,
              containerPoint: containerPoint,
              originalEvent: e
            });
            // eslint-disable-next-line no-empty
          } catch (e) {}
        },
        _onTouchStart: function _onTouchStart(e) {
          this._onTouchEvent(e, "mousedown");
        },
        _onTouchEnd: function _onTouchEnd(e) {
          if (!this._map._loaded) {
            return;
          }
          this._map.fire("mouseup", {
            originalEvent: e
          });
        },
        _onTouchMove: function _onTouchMove(e) {
          this._onTouchEvent(e, "mousemove");
        }
      });
      L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend);
    }
  }]);
}();
export { _default as default };
export function getL() {
  return Promise.all([
  //@ts-ignore
  import( /* webpackChunkName: "chunks/leaflet" */"leaflet/src/Leaflet"), require( /* webpackChunkName: "chunks/leaflet" */"leaflet/dist/leaflet.css")]);
}